import { Box } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button, Modal, ConfigProvider } from "antd";
import React from "react";
import { useEffect } from "react";
import {
  celsiusToFahrenheit,
  updateSelectedAlert,
  celsiusToFahrenheitRounded,
  removeAccountPrefix,
  convertReelableBatteryValue
} from "../../../global/utility/Utils";
import { useDispatch, useSelector } from "react-redux";
import {
  singleUpdateField,
  singleUpdateResponse,
  singleUpdateSubmit,
} from "../../../store/actions/alertsShipment";
import { updateUI } from "../../../store/actions/alerts";
import { dateFormatWithAt } from "../../../global/utility/dateFormat";
import {calculateRms} from "../../../global/utility/Utils";
import { Link } from "react-router-dom";
import { fetchRequest } from "../../../store/actions/alertsShipment";
import getAddressfromLatLong from "../../../global/utility/getAddressfromLatLong";

const AlertsShipmentDetails = ({ visible, closePopup, setActiveTab }) => {
  const dispatch = useDispatch();
  const idFormSubmitting = useSelector(
    (state) => state.alertsShipment.singleUpdate.isUpdating
  );
  const filters = useSelector((state) => state.alertsShipment.filters);
  const { currentData, attributes } = useSelector((state) => {
    let attributes = [];
    if (state?.alert?.singleUpdate?.currentData?.batteryValue?.deviceAlarm) {
      const attribs = Object.entries(
        state?.alert?.singleUpdate?.currentData?.batteryValue?.deviceAlarm
      );
      for (let i = 0; i < attribs.length; i++) {
        if (attribs[i][0] === "temperature") {
          attributes.push({
            attribute: attribs[i][0],
            minmax:
              state?.alert?.singleUpdate?.currentData?.batteryCriticalValue ===
              "Maximum"
                ? celsiusToFahrenheitRounded(attribs[i][1]?.ThresholdRange)
                : celsiusToFahrenheitRounded(attribs[i][1]?.Threshold),
            currentvalue: celsiusToFahrenheit(attribs[i][1]?.sensorReading),
          });
        }else if(attribs[i][0] === "gyro"|| attribs[i][0] === "tilt") {
            attributes.push({
              attribute: attribs[i][0],
              minmax: attribs[i][1]?.tilt_angle,
              currentvalue: attribs[i][1]?.inclination,
            });
          }
          else if(attribs[i][0] === "shock"|| attribs[i][0] === "motionDetected") {
            attributes.push({
              attribute: attribs[i][0],
              currentvalue: calculateRms(attribs[i][1]?.x,attribs[i][1]?.y,attribs[i][1]?.z),
            });
          } else {
          attributes.push({
            attribute: attribs[i][0],
            minmax:
              state?.alert?.singleUpdate?.currentData?.batteryCriticalValue ===
              "Maximum"
                ? attribs[i][1]?.ThresholdRange
                : attribs[i][1]?.Threshold,
            currentvalue: attribs[i][1]?.sensorReading,
          });
        }
      }
    }
    return {
      currentData: state.alertsShipment.singleUpdate.currentData,
      attributes,
    };
  });
  const shouldHide =
  currentData?.record?.condition?.includes("geoFenceEvent") ||
  Object.keys(currentData?.batteryValue?.deviceAlarm ?? {}).some(
    key => key === "shock" || key === "motionDetected"
  );
  const record = currentData?.record;
  const { locationDetails } = useSelector((state) => ({
    locationDetails: state.alert.ui,
  }));
  const fields = useSelector(
    (state) => state.alertsShipment.singleUpdate.fields
  );

  useEffect(() => {
    if (visible) {
      dispatch(
        singleUpdateField({
          status: undefined,
          comment: "",
        })
      );
    }
  }, [visible, dispatch]);

  const handleClick = async (val) => {
    dispatch(singleUpdateSubmit());
    let payload = JSON.stringify({
      accountName: currentData?.billingaccountid,
      comment: fields?.comment,
      resourceidentifier: {
        id: currentData?.id,
      },
      smartalert: {
        isacknowledged: val === "Ack",
        iscleared: val === "res",
        isdisabled: null,
        name: "",
      },
    });
    const res = await updateSelectedAlert(payload);

    if (res?.id) {
      closePopup(false);
      dispatch(
        singleUpdateResponse({
          isActive: true,
          message: "Edit Alert",
          description: `Alert for ${currentData?.name} updated successfully`,
        })
      );
      dispatch(
        fetchRequest({
          ...filters,
          isLoaded: true,
        })
      );
    }
  };

  let stamp = currentData?.name
    ? currentData?.name?.slice(currentData.name.length - 1)
    : "%";
  const location = currentData?.record?.metadata?.eventMsg?.fields?.location;
  useEffect(() => {
    const fetchAddress = async () => {
      if (location?.latitude && location?.longitude) {
        const address = await getAddressfromLatLong(
          location.latitude,
          location.longitude
        );
        dispatch(
          updateUI({
            key: "alertLocation",
            value: {
              IsLocationDetails: address,
            },
          })
        );
      }
    };
    fetchAddress();
  }, [location]);
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#000000",
          controlOutlineWidth: 0.1,
        },
      }}
    >
      <Modal
        title=""
        visible={visible}
        onCancel={() => closePopup(false)}
        footer={
          currentData?.record?.iscleared
            ? [
                <Grid2 container spacing={4} columns={{ xs: 12 }}>
                    <div className="w-100 ats-alert-close-btn ms-1 px-2">
                      <Button
                        className="custom-button-save"
                        type="default"
                        onClick={() => closePopup(true)}
                        shape="round"
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "black",
                          width: "100%",
                        }}
                        size={"large"}
                      >
                        <div style={{ fontFamily: "VerizonNHGDS" }}>Close</div>
                      </Button>
                    </div>
                </Grid2>,
              ]
              :
              currentData.status==="Acknowledged"? [
                <Grid2 container spacing={4} columns={{ xs: 12 }}>
                    <div className="w-100 ats-alert-close-btn ms-1 px-2">
                      <Button
                        className="custom-button-save"
                        type="default"
                        onClick={() => handleClick("res")}
                        shape="round"
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "black",
                          width: "100%",
                        }}
                        size={"large"}
                      >
                         <div style={{ fontFamily: "VerizonNHGDS" }}>
                          Mark as resolved
                        </div>
                      </Button>
                    </div>
                </Grid2>,
              ]
            : [
                <Grid2 container spacing={4} columns={{ xs: 12 }}>
                  <Grid2 item xs={12} sm={6} md={6} lg={6}>
                    <div className="mb-3">
                      <Button
                        className="custom-button-cancel"
                        type="default"
                        onClick={() => handleClick("res")}
                        shape="round"
                        style={{
                          fontWeight: "bold",
                          width: "100%",
                          opacity:
                            currentData?.status === "Auto Resolved" && 0.1,
                        }}
                        size={"large"}
                        disabled={ currentData?.status === "Auto Resolved"}
                      >
                        <div style={{ fontFamily: "VerizonNHGDS" }}>
                          Mark as resolved
                        </div>
                      </Button>
                    </div>
                  </Grid2>

                  <Grid2 item xs={12} sm={6} md={6} lg={6}>
                    <div className="mb-3">
                      <Button
                        className="custom-button-save"
                        type="primary"
                        onClick={() => handleClick("Ack")}
                        shape="round"
                        style={{
                          width: "100%",
                          backgroundColor: "black",
                          color: "white",
                          fontWeight: "bold",
                          opacity:
                            currentData?.status === "Auto Resolved" && 0.1,
                        }}
                        size={"large"}
                        disabled={
                          idFormSubmitting ||
                          currentData?.status === "Acknowledge" ||
                          currentData?.status === "Auto Resolved"
                        }
                      >
                        <div style={{ fontFamily: "VerizonNHGDS" }}>
                          Mark as acknowledged
                        </div>
                      </Button>
                    </div>
                  </Grid2>
                </Grid2>,
              ]
        }
        width={680}
      >
        <Box className="alert-modal-content">
          <Grid2 container xs={12} spacing={2} sm={12} md={12} direction="row">
            <div className="alert-infos">
              <span
                className={`alarm-status-${currentData?.status?.split(" ")?.join("")?.toLowerCase()}`}
              >
                {currentData?.status}
              </span>
              <span
                className={
                  currentData?.level?.toLowerCase() === "critical"
                    ? "alarm-condition-error" // Changed to "Critical"
                     :currentData?.level?.toLowerCase() === "minor"? "alarm-condition-notification":"alarm-condition" // Keep this for "New"
                }
              >
                {currentData?.level?.toLowerCase() === "major"
                  ? "Warning"
                  : currentData.level?.toLowerCase() === "minor"
                  ? "Notification"
                  : currentData.level}
              </span>
            </div>
          </Grid2>

          <div
            style={{
              fontFamily: "VerizonNHGDS",
              fontSize: "32px",
              fontWeight: "700 !important",
              paddingTop: "1%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "left",
            }}
          >
            <span className="font-face-vzw">Alert Details</span>
          </div>

          {/* Added space below Alarm Details */}
          <Box
            sx={{
              fontFamily: "VerizonNHGDS",
              fontSize: "16px",
              fontWeight: "400 !important",
              lineHeight: "20px",
              letterSpacing: "0.5px",
              textAlign: "left",
              paddingTop: "5%",
              paddingBottom: "40px", // Added a 40px gap below the subject
            }}
          >
            <span className="font-face-vzw">Subject:</span>
            <p style={{ marginTop: 5 }}>{currentData.name}</p>
          </Box>

          {/* Table Format */}
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginLeft: -10,
              marginTop: -40,
            }}
          >
            <thead>
              <tr>
                <th
                  className="font-face-vzw"
                  style={{
                    textAlign: "left",
                    borderBottom: "1px solid #ddd",
                    fontWeight: "bold",
                  }}
                >
                  Attribute
                </th>
                {shouldHide ? (
                  ""
                ) : (
                  <th
                    className="font-face-vzw"
                    style={{
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      fontWeight: "bold",
                    }}
                  >
                    {currentData?.batteryCriticalValue}
                  </th>
                )}
                {currentData?.record?.condition?.includes("geoFenceEvent") ? (
                  <th
                    className="font-face-vzw"
                    style={{
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      fontWeight: "bold",
                    }}
                  >
                    Current Location
                  </th>
                ) : (
                  <th
                    className="font-face-vzw"
                    style={{
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      fontWeight: "bold",
                    }}
                  >
                    Current Value
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ borderBottom: "1px solid #ddd", fontSize: 16 }}>
                  {Array.isArray(attributes) && attributes.length > 0
                    ? attributes[0].attribute
                    : (currentData && currentData.batteryValue &&
                        Object.keys(currentData?.batteryValue).length > 0 &&
                        Object.keys(currentData?.batteryValue)[0]) ||
                      "Unknown"}
                </td>
                {shouldHide ? (
                  ""
                ) : (
                  <td style={{ borderBottom: "1px solid #ddd", fontSize: 16 }}>
                    {attributes.length > 0
                      ? attributes[0].minmax
                      : currentData?.criticalValue?.replace(/[)\]]+$/, "")}
                  </td>
                )}

                {currentData?.record?.condition?.includes("geoFenceEvent") ? (
                  <>
                    <td
                      style={{ borderBottom: "1px solid #ddd", fontSize: 16 }}
                    >
                      {location?.latitude}, {location?.longitude}
                      <br />
                      {locationDetails?.alertLocation?.IsLocationDetails}
                    </td>
                  </>
                ) : (
                    <td style={{ borderBottom: "1px solid #ddd", fontSize: 16 }}>
                      {attributes.length > 0 ? (
                        attributes[0].currentvalue
                      ) : Object.hasOwn(currentData, "batteryValue") &&
                        currentData.batteryValue &&
                        Object.keys(currentData?.batteryValue).length > 0 ? (
                        (() => {
                          const batteryKey = Object.keys(currentData.batteryValue)[0];
                          const batteryValue = currentData.batteryValue[batteryKey];
                          switch (batteryKey) {
                            case "temperature":
                              return celsiusToFahrenheit(batteryValue)?.toFixed(2);
                            case "battery":
                              return convertReelableBatteryValue(parseFloat(batteryValue));
                            default:
                              return batteryValue;
                          }
                        })()
                      ) : "N/A"}
                  </td>
                )}
              </tr>
            </tbody>
          </table>

          <Grid2
            container
            spacing={2}
            style={{ marginLeft: -10, marginTop: 20 }}
          >
            <Grid2 item xs={6}>
              <label className="font-face-vzw">Time Occurred</label>
              <br />
              {dateFormatWithAt(currentData?.createdon)}{" "}
              {/* Replaced "Organization" with "Time Occurred" */}
            </Grid2>

            <Grid2 item xs={6}>
              <label className="font-face-vzw">Last Updated</label>{" "}
              {/* Replaced "Location" with "LastUpdated" */}
              <br />
              {dateFormatWithAt(currentData?.lastupdated)}{" "}
              {/* Replaced "Organization" with "Time Occurred" */}
            </Grid2>

             <Grid2 item xs={6}>
              <label className="font-face-vzw">Shipment</label>{" "}
              {/* Replaced "Device" with "Shipment" */}
              <br />
              { Object.hasOwn(currentData, "shipment") &&
                currentData.shipment ? <Link
                className="link-alarms"
                to={
                  Object.hasOwn(currentData, "shipment") &&
                  currentData.shipment?.startsWith("{{$")
                    ? undefined
                    :record?.metadata?.shipmentid!=="N/A"? `/viewshipment/${record?.metadata?.shipmentid}`:"/shipments"
                }
                onClick={() => {
                    closePopup(false);
                  if (record?.metadata?.assetname) {
                    setActiveTab("map")
                  }
                }}
                // state={{
                //   alert: "map",
                //   id: record?.id,
                //   deviceid: record?.deviceid,
                //   gateway: record?.deviceType?.startsWith("A"),
                //   shipmentData: {
                //     shipmentid: record?.metadata?.shipmentid,
                //     shipmentname: currentData.shipment,
                //     deviceid: record?.deviceId,
                //     updatedat: record?.lastUpdated,
                //     origin: record?.origin,
                //     destination: record?.destination,
                //     devicetype: record?.deviceType,
                //     startdate: record?.startDate,
                //     completiondate: record?.completionDate,
                //     deviceprofile: record?.deviceProfile,
                //     oncompletion: record?.profileUponCompletion,
                //     devicename: record?.metadata["device-name"],
                //     devicetype: record?.devicetype,
                //     oncompletion: record?.oncompletion,
                //     deviceid: record?.deviceid,
                //     startDateOriginal: record?.startDateOriginal,
                //   },
                // }}
              >
                {Object.hasOwn(currentData, "shipment") &&
                currentData.shipment &&
                currentData.shipment?.startsWith("{{$")
                  ? "Unknown"
                  : currentData.shipment || "Unknown"}
              </Link> : "Unknown"}
            </Grid2>

            <Grid2 item xs={6}>
              <label className="font-face-vzw">Alert Group</label>{" "}
              {/* Replaced "Time Occurred" with "Alert Group" */}
              <br />
               {removeAccountPrefix(currentData.alertgroup)}
            </Grid2>
          </Grid2>
        </Box>
      </Modal>
    </ConfigProvider>
  );
};

export default AlertsShipmentDetails;
